import { useQuery, useQueryClient } from "@tanstack/react-query";
import useAuthenticatedApiRequest from "../../AuthenticatedApiRequest";
import TchrURL from "../../TchrURL";

const useCheckoutSession = ({
  sessionId,
  enabled,
}: {
  sessionId: string;
  enabled: boolean;
}) => {
  const { get } = useAuthenticatedApiRequest();
  const queryClient = useQueryClient();
  return useQuery<string, Error, string>({
    queryKey: ["checkout", "session", sessionId],
    queryFn: async () => {
      const searchParams = new URLSearchParams();
      searchParams.append("sessionId", sessionId);
      const url = new TchrURL("/payment/sessionstatus");
      url.search = searchParams.toString();
      const response = await get(url);

      if (response.ok) {
        queryClient.invalidateQueries({ queryKey: ["user"] });
      }
      return response.json();
    },
    enabled: enabled && !!sessionId,
  });
};

export default useCheckoutSession;
